import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import TeamMembers from './TeamMembers';
import TeamMembersEdit from './TeamMembersEdit';
import { floatFormat, getOwnershipOptionByWorkType } from '../../utils';

class AgreementDetailSplitUpdate extends Component {
  constructor() {
    super();
    this.state = {
      blocks: [],
      works: [],
      showAgreementText: false,
      editMembers: false,
      members: [],
      nextCollaborator: null,
      currentMemeber: null,
    };
  }

  componentWillMount() {
    const { params, agreement } = this.props;

    if (params && params.agreementId) {
      this.props.loadAgreement(params.agreementId);
      this.props.loadBlockContents(params.agreementId);
    } else if (agreement) {
      this.props.loadAgreement(agreement.id);
      this.props.loadBlockContents(agreement.id);
    }
    this.props.assignAttribute('memberPublishers', []);
  }

  componentWillReceiveProps(nextProps) {
    const { status, agreement, contractBlocks, agreementContractBlocks } =
      nextProps;

    if (this.props.status !== status) {
      if (status === actionTypes.AGREEMENT_GET_SUCCESS && agreement) {
        let deals = agreement.deals || [];
        deals = R.filter((deal) => deal.progress === 100, deals);
        if (deals.length) {
          this.props.loadDealUsers(deals[deals.length - 1].id);
        }
      } else if (
        status === actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_SUCCESS &&
        contractBlocks &&
        agreementContractBlocks
      ) {
        const blocks = [];

        contractBlocks.forEach((block, i) => {
          const index = R.findIndex(R.propEq('contract_block', block.id))(
            agreementContractBlocks
          );
          if (index !== -1) {
            block.content = agreementContractBlocks[index].content;
            block.options = JSON.parse(agreementContractBlocks[index].options);
          }
          blocks.push(block);
        });

        this.setState({ blocks });
      }
    }

    let works = agreement ? agreement.works || [] : [];

    if (works.length && !R.equals(works, this.state.works)) {
      works = R.sortBy(R.prop('date_created'), works);
      this.setState({ works });
    }
  }

  componentWillUnmount() {
    this.setState({ editMembers: false });
  }

  handleNextPage() {
    const { agreement, fields, ownershipTypes } = this.props;
    const { editMembers } = this.state;

    this.props.hideAlert();

    let members;
    let memberPublishers = [];

    if (editMembers) {
      members = this.state.members;
      members.forEach((member) => {
        if (member.publishers && member.publishers.length) {
          memberPublishers.push(member);
        }
      });
      this.props.assignAttribute('memberPublishers', memberPublishers);
    } else {
      const pubMembers = R.filter(
        (user) => user.type === 'member',
        this.props.dealUsers
      );
      pubMembers.forEach((member) => {
        if (member.publishers && member.publishers.length) {
          memberPublishers.push(member);
        }
      });
      this.props.assignAttribute('memberPublishers', memberPublishers);

      const workOwnerships = this.state.works[0].work_ownership_info.map(
        (info) => {
          return {
            user: info.user,
            role_ids: info.role_ids,
            ownership_type: info.ownership_type,
            percentage: floatFormat(info.percentage),
          };
        }
      );
      this.props.setWorkOwnerships(workOwnerships);

      return true;
    }

    if (members) {
      let { currentMemeber } = this.state;

      let sum = 0;
      let hasOwnership = true;
      let ownershipMember = null;
      let hasPercentage = true;
      let percentageMember = null;
      const ownershipOption = getOwnershipOptionByWorkType(
        fields.type,
        fields.subtype,
        ownershipTypes
      );

      if (!currentMemeber) {
        currentMemeber = members[0];
      }

      members.forEach((member) => {
        if (member.ownership && member.ownership.percentage) {
          sum += parseFloat(member.ownership.percentage, 10);
        }
      });

      members.forEach((member) => {
        if (member.ownership) {
          if (member.ownership.percentage && sum !== 100) {
            if (member.ownership.percentage === '0.00') {
              if (member.user === currentMemeber.user) {
                hasPercentage = false;
              } else {
                if (!percentageMember) {
                  percentageMember = member;
                }
              }
            }
          }

          if (member.ownership.ownership_type === 0) {
            if (member.user === currentMemeber.user) {
              hasOwnership = false;
            } else {
              if (!ownershipMember) {
                ownershipMember = member;
              }
            }
          } else {
            // Ignore ownership set in team profile
            if (member.ownership.ownership_type !== 1) {
              // If it's not NoOwnership
              if (member.ownership.ownership_type !== ownershipOption.id) {
                if (member.user === currentMemeber.user) {
                  hasOwnership = false;
                } else {
                  if (!ownershipMember) {
                    ownershipMember = member;
                  }
                }
              }
            }
          }
        } else {
          if (member.user === currentMemeber.user) {
            hasOwnership = false;
          } else {
            if (!ownershipMember) {
              ownershipMember = member;
            }
          }
        }
      });

      if (!hasOwnership) {
        this.props.alert(
          'error',
          'Please select an ownership type for each collaborator.'
        );
        return false;
      }

      if (ownershipMember) {
        this.setState({
          nextCollaborator: ownershipMember,
          currentMemeber: ownershipMember,
        });
        return false;
      }

      if (!hasPercentage) {
        this.props.alert(
          'error',
          'The ownership splits must total 100% before you can continue.'
        );
        return false;
      }

      if (percentageMember) {
        this.setState({
          nextCollaborator: percentageMember,
          currentMemeber: percentageMember,
        });
        return false;
      }

      if (sum !== 100) {
        this.props.alert(
          'error',
          'The ownership splits must total 100% before you can continue.'
        );
        return false;
      }

      if (editMembers) {
        const workOwnerships = members.map((member) => {
          if (member.default === true) {
            this.props.updateOwnership({
              id: member.ownership.id,
              team: agreement.team,
              team_user: member.id,
              ownership_type: member.ownership.ownership_type,
              percentage: floatFormat(member.ownership.percentage),
            });
          }

          return {
            user: member.user,
            role_ids: member.role_ids,
            ownership_type: member.ownership.ownership_type,
            percentage: floatFormat(member.ownership.percentage),
          };
        });

        this.props.setWorkOwnerships(workOwnerships);
      }
    }
    return true;
  }

  handleNext() {
    if (this.handleNextPage()) {
      this.setState({ nextCollaborator: null }, () => {
        this.props.router.push('/create/review/agreement-detail-split-update');
      });
    }
  }

  handlePrev() {
    this.props.router.push('/create/agreement-detail');
  }

  setCurrentMember = (member) => {
    this.setState({ currentMemeber: member });
  };

  render() {
    const { agreement, members } = this.props;

    return (
      <div className="agreement-detail">
        <Heading text="Split Details" />

        {agreement && (
          <div className="content">
            <h3>{agreement.name}</h3>

            <div>
              <p className="text-gray">
                This is the ownership split and licensing permission information
                that Cosynd has stored for everyone involved in this split
                sheet. To change the split information for the new copyright(s),
                click on “edit.” Otherwise, click on “next” to continue as is.
              </p>
            </div>

            {this.state.works &&
              this.state.works.length > 0 &&
              (this.state.editMembers ? (
                <TeamMembersEdit
                  type="create"
                  team={agreement.team}
                  members={members}
                  soundRecordingType={this.state.works[0].sound_recording_type}
                  nextCollaborator={this.state.nextCollaborator}
                  onUpdateMembers={(members) => this.setState({ members })}
                  setCurrentMember={this.setCurrentMember}
                />
              ) : (
                <TeamMembers
                  type="create"
                  agreeType={agreement.type}
                  teamId={agreement.team}
                  work={this.state.works[0]}
                  hideValue={false}
                  onEdit={() => this.setState({ editMembers: true })}
                />
              ))}
          </div>
        )}

        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrev()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  agreement: state.agreements.selectedAgreement,
  members: state.users.members,
  contractBlocks: state.global.contractBlocks,
  agreementContractBlocks: state.agreements.contractBlocks,
  status: state.agreements.status,
  error: state.agreements.error,
  dealUsers: state.dealUsers.dealUsers,
  invites: state.invites.invites,
  ownershipTypes: state.global.ownershipTypes,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadAgreement: (id) => {
    dispatch(actions.getAgreement(id));
  },
  loadBlockContents: (agreementId) => {
    dispatch(actions.getAgreementContractBlockContents(agreementId));
  },
  deleteAgreement: (id) => {
    dispatch(actions.deleteAgreement(id));
  },
  updateOwnership: (ownership) => {
    dispatch(actions.updateMemberOwnership(ownership));
  },
  setWorkOwnerships: (workOwnerships) => {
    dispatch(actions.setWorkOwnerships(workOwnerships));
  },
  loadDealUsers: (dealId) => {
    dispatch(actions.getDealUsers(dealId));
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgreementDetailSplitUpdate);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementDetailSplitUpdate.jsx